import {FireInTheHole2} from "../FireInTheHole2";
import Spine = PIXI.spine.Spine;
import {TweenLite, gsap} from "gsap";
import {FITH2GameConfig} from "../configs/FITH2GameConfig";
import {FITH2SoundManager} from "../sound/FITH2SoundManager";
import {ArrayHelper} from "@nolimit/slot-game/bin/utils/ArrayHelper";
import {FITH2Helper} from "../utils/FITH2Helper";
import {Sprite} from "pixi.js";

export class FITH2ReelAnticipation extends PIXI.Container {
    private _isPlayingAnticipation: boolean;
    private _playingOnReel: boolean[];
    private _animation: Spine;
    private _topGradients:PIXI.Sprite[];

    constructor() {
        super();
        this.name = "ReelAnticipation";
        this._isPlayingAnticipation = false;
        this._playingOnReel = ArrayHelper.initArrayWithValues(6, ()=>false);
        this.init();
    }

    private init() {
        this._animation  = new Spine(FireInTheHole2.assetLoader.getSpineAsset("anticipation"));
        this._animation.name = "ReelAnticipation";
        this._animation.alpha = 0;
        this._animation.visible = false;
        this._animation.position.set(0, 0);
        this._topGradients = ArrayHelper.initArrayWithValues(6, (i: number) => {
            const gradient: Sprite = new Sprite(FireInTheHole2.assetLoader.getTextures("reel_highlight")[0]);
            gradient.name = "ReelGradient";
            gradient.alpha = 0;
            gradient.visible = false;
            gradient.blendMode = PIXI.BLEND_MODES.SCREEN;
            gradient.anchor.set(0, 0);
            gradient.position.set(FITH2GameConfig.reelAreaPos.x+FITH2GameConfig.reelPositions[i].x-360-60, FITH2GameConfig.reelAreaPos.y+4-360);
            return gradient;
        });
        this.position.set(360,360);
    }

    public fadeOut(reelId: number): void {
        if(!this._isPlayingAnticipation){
            return;
        }
        new gsap.core.Timeline().add(TweenLite.to(this._topGradients[reelId], 0.3, {alpha: 0}))
            .add(()=>{
                this._topGradients[reelId].visible = false;
                if(this._isPlayingAnticipation){
                    this.update(reelId+1)
                }
            });
    }

    public fadeOutAnticipationSound(): void {
        if (this._isPlayingAnticipation) {
            FITH2SoundManager.fadeSoundEffect("scatterAnticipation", 1, 0, 500);
        }
    }

    public reset(): void {
        if (this._isPlayingAnticipation) {
            this._isPlayingAnticipation = false;
            if (!FireInTheHole2.model.freespinTriggeredThisSpin) {
                FireInTheHole2.reelFrame.onAnticipationFail();
            }
            FireInTheHole2.background.removeDimmer();
            FITH2SoundManager.stopAnticipationSound();
            FITH2SoundManager.playSound(`scatterAnticipationEnd`);
                FITH2Helper.resetSpineItem(this._animation);
                this._animation.alpha = 0;
                this._animation.visible = false;
            this._topGradients.forEach((gradient: Sprite) => {
                gradient.alpha = 0;
                gradient.visible = false;
            });
        }
    }

    public update(reelId: number): void {
        if (FITH2Helper.isFreeSpin(FireInTheHole2.model.data.mode)) {
            return;
        }

        const isNextRespin:boolean = FireInTheHole2.model.isNextRespin;
        if (reelId === 6) {
            if(!isNextRespin){
                this.reset();
            }
            return;
        }

        if (this._topGradients[reelId].visible) {
            return;
        }

        if (FireInTheHole2.model.nearWinReels[reelId]) {
            FITH2SoundManager.playAnticipationSound();
            this._topGradients[reelId].visible = true;
            if(!this._isPlayingAnticipation){
                FireInTheHole2.background.addDimmer();
            }
            this._isPlayingAnticipation = true;
            if(!this._animation.visible){
                this._animation.visible = true;
                this.addChild(this._animation);
                this._animation.state.setAnimation(0, "base", true);
                TweenLite.to(this._animation, 0.1, {alpha: 1});
            }
            this.addChild(this._topGradients[reelId]);
            TweenLite.to(this._topGradients[reelId], 0.1, {alpha: 1});
        }
    }
}